import { useLayoutEffect, useState } from "react";
import { getSubscriptionInfo } from "../api";
import { useVestaboardQueryParams } from "@vestaboard/installables";

export const useSubscription = () => {
  const { subscriptionId, subscriptionConfigToken, platform } =
    useVestaboardQueryParams();
  const [title, setTitle] = useState("");
  const [boardId, setBoardId] = useState("");
  const [boardTitle, setBoardTitle] = useState("");
  const [boardStyle, setBoardStyle] = useState("");
  const [boardPreview, setBoardPreview] = useState();

  useLayoutEffect(() => {
    if (subscriptionConfigToken && !boardId) {
      getSubscriptionInfo(subscriptionConfigToken).then(({ subscription }) => {
        if (subscription?.title) {
          // initialize title with user title if they customized their subscription
          setTitle(subscription?.title);
        }
        const boardId = subscription.board[0].id;
        const subscriptionBoardStyle = subscription.board[0].boardStyle;
        setBoardId(boardId);
        setBoardTitle(subscription.board[0].title);
        const subscriptionPreview = subscriptionBoardStyle?.includes("note")
          ? subscription.marketplaceListing?.notePreviewMessage
          : subscription.marketplaceListing?.previewMessage;
        subscriptionPreview && setBoardPreview(JSON.parse(subscriptionPreview));
        subscriptionBoardStyle && setBoardStyle(subscriptionBoardStyle);
      });
    }
  }, [
    subscriptionConfigToken,
    boardId,
    boardPreview,
    boardTitle,
    boardStyle,
    title,
  ]);

  return {
    subscriptionId,
    subscriptionConfigToken,
    platform,
    title,
    setTitle,
    boardTitle,
    boardId,
    boardStyle,
    boardPreview,
    loading: !boardId,
  };
};
